const millisecond = 1;
const second = 1000;
const minute = second * 60;
const hour = minute * 60;
const day = hour * 24;

export const timeUnit = {
  millisecond,
  second,
  minute,
  hour,
  day,
} as const;

export type TimeUnit = keyof typeof timeUnit;

export function sleep(duration: number, unit: number = timeUnit.millisecond) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(null), duration * unit);
  });
}

export function convertDuration(
  duration: number,
  from: TimeUnit,
  to: TimeUnit
) {
  return (duration * timeUnit[from]) / timeUnit[to];
}
